// services/userService.js
import axios from 'axios';
import { api } from '../../constants/api';

const userService = {
    checkUsernameAvailability: async (userName) => {
        try {
            const response = await axios.post(api.services.checkUserNameAvailablity, { userName });
            return response.data; // Return the whole response data to handle in the component
        } catch (error) {
            console.error("Error checking username availability", error);
            throw error;
        }
    },

    generateBusinessName: async (inputValue) => {
        try {
            const response = await axios.post(api.tools.generate, { input: inputValue });
            return response.data;
        } catch (error) {
            console.error("Error generating business name", error);
            throw error;
        }
    },

    checkDomainAvailability: async (domain) => {
        try {
            const response = await axios.post(api.tools.domainCheck, { params: { domain } });
            return response.data;
        } catch (error) {
            console.error("Error checking domain availability", error);
            throw error;
        }
    },

    getAiImage: async (prompt) => {
        try {
            const response = await fetch(api.customize.fetchImage, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ prompt })
            });
    
            if (!response.ok) {
                throw new Error('Error fetching AI image');
            }
    
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error fetching AI image", error);
            throw error;
        }
    },
    generateFreeImage: async (prompt) => {
        try {
            const response = await fetch(api.tools.generateFreeImage, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ prompt })
            });
    
            if (!response.ok) {
                throw new Error('Error fetching AI images');
            }
    
            const data = await response.json();
            return data.images; // This will be an array of image URLs
        } catch (error) {
            console.error("Error fetching AI images", error);
            throw error;
        }
    },

};

export default userService;
